import React, { useEffect, useState } from "react";
import getBrowserFingerprint from 'get-browser-fingerprint';
import axios from "axios";
import { Base64 } from 'js-base64';

export default function QuizData({ idTraineData: propIdTraineData = "" ,showHeader }) {
  const [quizQuestions, setQuizQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [resultsJson, setResultsJson] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const fingerprint = getBrowserFingerprint();

  useEffect(() => {
    const fetchQuiz = async () => {
      try {
        let idagencyTraineData = localStorage.getItem("idagencyTraineData")
          ? parseInt(localStorage.getItem("idagencyTraineData"), 10)
          : propIdTraineData;

        if (idagencyTraineData === null) {
          localStorage.setItem("AID", Base64.encode(fingerprint + "A1"));
          return;
        }
        const res = await axios.post(
          process.env.REACT_APP_API_ENDPOINT + "/getagencyquizz",
          { idagencyTraineData }
        );

        if (res.data && Array.isArray(res.data)) {
          setQuizQuestions(res.data); // Assuming API returns quiz questions array
          setCurrentIndex(0);
        } else {
          setErrorMsg("No quiz questions available. Please contact support.");
        }
      } catch (error) {
        setErrorMsg("Error fetching quiz questions.");
        
      }
    };
    fetchQuiz();
  }, [fingerprint, propIdTraineData]);

  const currentQ = quizQuestions[currentIndex] || {};
  const selectedForCurrent = selectedOptions[currentQ.id] ?? null;

  const handleOptionClick = (ans_id) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [currentQ.id]: ans_id,
    }));
    setErrorMsg("");
  };

  const handleNext = () => {
  if (!selectedForCurrent) {
    setErrorMsg("Please select an answer before proceeding.");
    return;
  }
  setErrorMsg("");
  if (currentIndex < quizQuestions.length - 1) {
    setCurrentIndex(currentIndex + 1);
  }
};

const handlePrev = () => {
  setErrorMsg("");
  if (currentIndex > 0) {
    setCurrentIndex(currentIndex - 1);
  }
};

const getMissingRequiredQuestions = () => {
  const missing = [];
  quizQuestions.forEach((q, idx) => {
    if (!selectedOptions[q.id]) {
      missing.push({ id: q.id, idx, title: q.title });
    }
  });
  return missing;
};

const handleSubmit = async () => {
  if (!selectedForCurrent) {
    setErrorMsg("Please select an answer before submitting.");
    return;
  }

  const missing = getMissingRequiredQuestions();
  if (missing.length > 0) {
    const firstMissing = missing[0];
    setCurrentIndex(firstMissing.idx);
    setErrorMsg(
      `Please answer all questions. First unanswered: ${firstMissing.title || `Question ${firstMissing.idx + 1}`}`
    );
    return;
  }

  setErrorMsg("");

  const quizzDataArray = quizQuestions.map((q) => ({
    quesId: q.id,
    ansId: selectedOptions[q.id] || null,
  }));

  const idTraineDataStr = localStorage.getItem("idagencyTraineData");
  const idagencyTraineData = idTraineDataStr ? parseInt(idTraineDataStr, 10) : null;

  const payload = {
    idagencyTraineData,
    quizzData: quizzDataArray,
  };

  try {
    const res = await axios.post(
      process.env.REACT_APP_API_ENDPOINT + "/submitagencyquizz",
      payload
    );
    if (res) {
      setResultsJson(res.data);
      setShowResults(true);
      showHeader();
       localStorage.setItem("AID", Base64.encode(fingerprint + "A5"));
    } else {
      console.log("There was an error submitting the quiz. Please try again.");
    }
  } catch (err) {
    console.log("Failed to submit quiz. Server error.");
    
  }
};


  if (quizQuestions.length === 0) {
    return (
      <div className="container mt-5">
        {errorMsg ? <p className="text-danger">{errorMsg}</p> : <p>Loading quiz...</p>}
      </div>
    );
  }

  const isFirst = currentIndex === 0;
  const isLast = currentIndex === quizQuestions.length - 1;

  return (
    <>
      {showResults && resultsJson ? (
        <div className="mt-3">
          <div className="quiz-submission-summary p-5">
            <h2 className="text-center">{resultsJson?.returnArray?.h1Title}</h2>
    <h4 className="text-center">{resultsJson?.returnArray?.p1Title}</h4>
    <p className="text-center">
      {resultsJson?.returnArray?.p2Title}
    </p>
    <p className="text-center">
      {resultsJson?.returnArray?.p3Title}
    </p>
          </div>

          <div className="result-details mt-4">
            {resultsJson.finalArray.map((item, idx) => (
              <div key={idx} className="mb-3">
                <span className="quiz-question-result">{item.title}: {item.quizzQuestion}</span>
                {item.status === "correct" ? (
                  <span className="float-end quiz-answer-status" style={{ color: "#562274" }}>Correct</span>
                ) : (
                  <>
                    <span className="float-end quiz-answer-status" style={{ color: "red" }}>Incorrect</span>
                    <br />
                    <span className="quiz-correct-answer">Correct answer: {item.correctAnswer}</span>
                  </>
                )}
              </div>
            ))}
          </div>

          <div className="mt-4 float-end">
            <button className="btn-quiz-next" onClick={() => {
              // setShowResults(false);
              // setSelectedOptions({});
              // setCurrentIndex(0);
             localStorage.setItem("AID", Base64.encode(fingerprint + "A5"));
          window.location.reload();
            }}>
              NEXT
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-3">
          <h5 className="mb-4">
            {currentQ.topsection}
          </h5>
          <h6 className="mb-4">
            {currentQ.title}. {currentQ.description}
          </h6>

          <div className="list-group quiz-options-list">
            {currentQ.values?.map((opt, index) => {
              const isActive = selectedForCurrent === opt.ans_id;
              return (
                <button
                  key={opt.ans_id}
                  className={`quiz-options${isActive ? " active text-white" : ""}`}
                  onClick={() => handleOptionClick(opt.ans_id)}
                >
                  {String.fromCharCode(65 + index)}) {opt.description}
                </button>
              );
            })}
          </div>
          {errorMsg && (
            <p className="text-danger mb-0 quiz-error-msg">
              {errorMsg}
            </p>
          )}

          <div className="justify-content-between float-end">
            {!isFirst && (
              <button onClick={handlePrev} className="btn-quiz-previous">
                Previous
              </button>
            )}
            {isLast ? (
              <button onClick={handleSubmit} className="btn-quiz-next">
                Submit
              </button>
            ) : (
              <button onClick={handleNext} className="btn-quiz-next">
                Next
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
}
